var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.869,60.135c4.228,0,7.668,3.692,7.668,8.229,0,4.635-4.122,8.229-7.668,8.229s-7.668-3.595-7.668-8.229c0-4.538,3.44-8.229,7.668-8.229m0-3c-5.892,0-10.668,5.028-10.668,11.229s5.334,11.229,10.668,11.229,10.668-5.028,10.668-11.229-4.776-11.229-10.668-11.229h0Z",
    fill: "#47d5cd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.149,84.962c10.221,0,18.75,5.9,20.523,13.66H54.626c1.774-7.76,10.302-13.66,20.524-13.66m0-3c-12.484,0-22.728,7.898-23.774,17.959-.095,.911,.64,1.7,1.556,1.7h44.437c.916,0,1.65-.79,1.556-1.7-1.046-10.062-11.291-17.959-23.774-17.959h0Z",
    fill: "#47d5cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.257,63.749c2.778,0,5.037,2.45,5.037,5.46,0,3.075-2.708,5.46-5.037,5.46s-5.037-2.385-5.037-5.46c0-3.011,2.26-5.46,5.037-5.46m0-3c-4.439,0-8.037,3.788-8.037,8.46s4.019,8.46,8.037,8.46,8.037-3.788,8.037-8.46-3.598-8.46-8.037-8.46h0Z",
    fill: "#47d5cd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.743,63.749c2.778,0,5.037,2.45,5.037,5.46,0,3.075-2.708,5.46-5.037,5.46s-5.037-2.385-5.037-5.46c0-3.011,2.26-5.46,5.037-5.46m0-3c-4.439,0-8.037,3.788-8.037,8.46s4.019,8.46,8.037,8.46,8.037-3.788,8.037-8.46-3.598-8.46-8.037-8.46h0Z",
    fill: "#47d5cd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.111,97.297H30.49c-.829,0-1.5-.672-1.5-1.5,0-8.994,8.738-16.312,19.479-16.312,5.296,0,10.247,1.744,13.939,4.91,.629,.539,.702,1.486,.163,2.115-.539,.629-1.486,.7-2.115,.162-3.15-2.7-7.407-4.188-11.987-4.188-8.458,0-15.449,5.175-16.375,11.812h20.018c.829,0,1.5,.672,1.5,1.5s-.671,1.5-1.5,1.5Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,97.297h-21.621c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5h20.018c-.926-6.637-7.917-11.812-16.375-11.812-4.581,0-8.838,1.487-11.986,4.188-.629,.539-1.575,.467-2.115-.162-.539-.629-.467-1.576,.162-2.115,3.692-3.166,8.643-4.91,13.939-4.91,10.74,0,19.479,7.317,19.479,16.312,0,.828-.672,1.5-1.5,1.5Z",
    fill: "#47d5cd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.998,63.378c-.742,0-1.388-.551-1.485-1.307l-1.387-10.693h-8.252l-1.387,10.693c-.106,.822-.864,1.397-1.68,1.295-.822-.107-1.401-.859-1.295-1.681l1.556-12c.097-.748,.733-1.307,1.487-1.307h10.889c.754,0,1.391,.56,1.487,1.307l1.556,12c.106,.822-.473,1.574-1.295,1.681-.065,.008-.13,.012-.194,.012Z",
    fill: "#47d5cd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52,64.45c-.621,0-1.201-.389-1.417-1.008l-1.88-5.41-2.321,5.5c-.321,.764-1.2,1.123-1.965,.799-.764-.322-1.121-1.202-.799-1.965l3.839-9.097c.241-.572,.758-.943,1.431-.916,.62,.02,1.164,.42,1.368,1.007l3.161,9.097c.271,.782-.143,1.637-.925,1.909-.163,.057-.329,.083-.492,.083Z",
    fill: "#47d5cd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.587,64.776c-.238,0-.48-.057-.705-.177-.73-.39-1.008-1.299-.617-2.03l2.235-4.191h-9.5l2.235,4.191c.391,.731,.113,1.64-.617,2.03-.73,.389-1.641,.113-2.029-.618l-3.412-6.397c-.248-.465-.234-1.026,.037-1.478,.271-.452,.759-.729,1.286-.729h14.5c.527,0,1.016,.276,1.286,.729,.271,.452,.285,1.013,.037,1.478l-3.412,6.397c-.27,.506-.788,.794-1.324,.794Z",
    fill: "#47d5cd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.5264a0b7ded2fbef93d89fcd8de4782f.svg";
export { ForwardRef as ReactComponent };